module.exports = __webpack_public_path__ + "img/Noctiluca-Inspect-Medium.c6907859.png";